import GOVERNOR_ABI from "./abis/governor.json";
import { GOVERNOR_ADDRESSES } from "./variables";

export const GOV_ADDRESS = GOVERNOR_ADDRESSES;

export const GOV_ABI = GOVERNOR_ABI;
